
import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import _ from 'lodash';
import {getModule} from 'vuex-module-decorators';
import {
    store,
    TradeInModule,
    ShopModule,
    ReturnCarrierServiceModule
} from "@returns-centre/store";
import FurtherInformationModal from '@/returns-centre/components/modals/trade-in/FurtherInformationModal.vue';
import {mixins} from 'vue-class-component';
import {ResolveCurrencySymbolMixing} from '@/mixins';
import PolarisIcon from "@/packages/@eastsideco/polaris-vue/src/components/PolarisIcon.vue";
import { config } from '@/config';
import { ShippingOptionService } from '@/enums';

@Component({
    components: {
        PolarisIcon,
        FurtherInformationModal,
    }
})
export default class TradeInReturnCarrierServices
    extends mixins(ResolveCurrencySymbolMixing) {
    tradeInModule = getModule(TradeInModule, store);
    shopModule = getModule(ShopModule, store);
    returnCarrierServiceModule = getModule(ReturnCarrierServiceModule, store);
    selectedReturnCarrierService: ReturnCarrierService | null = null
    moreInfoReturnCarrierService: ReturnCarrierService | null = null
    returnCarrierServices: ReturnCarrierService[] = [];
    baseUrl = config.baseUrl;

    async created() {
        if (this.tradeInModule.trade_in) {
            await this.returnCarrierServiceModule.fetchReturnCarrierServices(this.tradeInModule!.trade_in!.id);
            this.returnCarrierServices = this.returnCarrierServiceModule.return_carrier_services;
            this.tradeInModule.setReturnCarrierServices(this.returnCarrierServices);
            this.selectedReturnCarrierService = this.tradeInModule.selected_return_carrier_service;
        }
    }

    getCustomerReturnShippingFee(returnCarrierService: ReturnCarrierService): number {
        if (!this.shopModule.shop) {
            return 0;
        }

        if ([ShippingOptionService.custom.toString(), ShippingOptionService.JGS.toString()].includes(returnCarrierService.service_class)) {
            return _.toNumber(returnCarrierService.cost_to_customer) ?? 0;
        }

        const returnCarrierServiceReturnCost = _.toNumber(returnCarrierService.rate) * 100;

        const merchantShippingFeeShare = (
            returnCarrierServiceReturnCost * this.shopModule.shop.shipping_fee_merchant_share_percentage
        ) / 100;

        const getCustomerReturnShippingFeeShare = merchantShippingFeeShare * (
            this.shopModule.shop.shipping_fee_customer_share_percentage / 100
        );

        return getCustomerReturnShippingFeeShare / 100;

    }

    getReturnCarrierServiceName(returnCarrierService: ReturnCarrierService): string {
        if ([ShippingOptionService.custom.toString(), ShippingOptionService.JGS.toString()].includes(returnCarrierService.service_class)) {
            return returnCarrierService.service_name;
        }

        return `${returnCarrierService.name} - ${returnCarrierService.service_name}`;
    }

    isItCustomShippingOption(returnCarrierService: ReturnCarrierService): boolean {
        return returnCarrierService.service_class === ShippingOptionService.custom;
    }

    @Watch('selectedReturnCarrierService', {deep: true})
    onSelectedReturnCarrierServiceChanged(returnCarrierService: ReturnCarrierService) {
        this.tradeInModule.setSelectedReturnCarrierService(returnCarrierService);
        const returnShippingFee = this.getCustomerReturnShippingFee(returnCarrierService);

        if (returnShippingFee > 0) {
            // do not change this slug value
            // - if you do then change in the database table deduction_types as well
            this.tradeInModule.setTradeInPriceDeduction({
                price: returnShippingFee,
                deduction_type: {
                    name: 'Return Shipping fee',
                    slug: 'shipping-fee',
                },
            });
        } else {
            this.tradeInModule.RESET_TRADE_IN_PRICE_DEDUCTION();
        }
    }

}
